/**
 * Validates if a string is a valid URL
 * @param {string} str - The string to validate
 * @returns {boolean} - True if string is a valid URL
 */
export const isValidUrl = str => {
	const value = String(str).trim();
	if (!value || /\s/.test(value)) return false;

	try {
		const url = new URL(/^https?:\/\//i.test(value) ? value : `https://${value}`);
		return ['http:', 'https:'].includes(url.protocol) && Boolean(url.hostname) && url.hostname.includes('.');
	} catch {
		return false;
	}
};

/**
 * Validates if a string is a valid Instagram handle
 * @param {string} str - The string to validate
 * @returns {boolean} - True if string is a valid Instagram handle
 */
export const isValidInstagramHandle = str => {
	const instagramPattern = /^@?[a-z0-9._]{1,30}$/i;
	return instagramPattern.test(String(str).trim());
};

/**
 * Validates if a string is either a valid URL or Instagram handle
 * @param {string} str - The string to validate
 * @returns {boolean} - True if string is either a valid URL or Instagram handle
 */
export const isValidUrlOrInstagram = str => {
	return isValidUrl(str) || isValidInstagramHandle(str);
};
